import {SET_API_ADDRESS,
        RESET_API_ADDRESS,
        SET_CSV_ADDRESS,
        RESET_CSV_ADDRESS} from '../constants/ActionTypes';

const initialState = {
    apiAddress: '',
    csvAddress: ''
};

export default function apiData(state = initialState, action) {
    switch (action.type) {
        case SET_API_ADDRESS:
            return {
                ...state,
                apiAddress: action.apiAddress
            };
        case RESET_API_ADDRESS:
            return {
                ...state,
                apiAddress: ''
            };
        case SET_CSV_ADDRESS:
            return {
                ...state,
                csvAddress: action.csvAddress
            };
        case RESET_CSV_ADDRESS:
            return {
                ...state,
                csvAddress: ''
            };
        default:
          return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/apiData.js